module.exports = __webpack_public_path__ + "img/logo.24f0a2d5.png";